import React from "react"
import { Link } from 'react-router-dom'
import moment from 'moment'
import 'moment/locale/pt-br'
import {
    IoAlertCircleOutline,
    IoAnalyticsOutline,
    IoChatbubblesOutline,
    IoEyeOffOutline,
    IoEyeOutline,
    IoHandRightOutline,
    IoHeartOutline,
    IoLockClosedOutline,
    IoMailOutline,
    IoMoonOutline,
    IoRefreshOutline,
    IoSunnyOutline
} from "react-icons/io5"
import './Login.css'
import './Onboarding/Onboarding.css'
import { Campo, PainelMarca } from './Onboarding/moldura'
import { salvarDadosDaUnidade } from './Auxiliaries/sessaoUnidade'
import { linkAjuda } from './Onboarding/api'


// O que a BIWAPP faz pela loja — o painel da esquerda do login
const BENEFICIOS = [
    { icone: IoRefreshOutline, titulo: 'Recupere clientes inativos', texto: 'Campanhas automáticas para quem sumiu voltar.' },
    { icone: IoHeartOutline, titulo: 'Fidelize clientes ativos', texto: 'Aniversário, avisos e lembretes no momento certo.' },
    { icone: IoChatbubblesOutline, titulo: 'Atenda clientes com I.A.', texto: 'Resposta na hora, 24h, com os preços da sua loja.' },
    { icone: IoAnalyticsOutline, titulo: 'Analise o atendimento humano', texto: 'Nota diária das conversas da sua equipe.' }
]

class Login extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: '',
            loginMsg: '',

            showPassword: false,
            loading: false,
            capsLock: false,
            isDarkMode: localStorage.getItem('login_theme') === 'dark',
            destaque: 0,    // item do painel da marca aceso agora
            pulso: false    // depois do último: todos acendem e apagam juntos
        }
    }

    componentDidMount() {
        const savedTheme = localStorage.getItem('login_theme')
        if (savedTheme) {
            this.setState({ isDarkMode: savedTheme === 'dark' })
        }
        // O painel da esquerda vai acendendo sozinho cada coisa que a BIWAPP
        // faz, a cada 2s (no cadastro, quem acende é o passo atual). Quem
        // pediu menos movimento no sistema vê o primeiro item parado.
        // Cada passo dura PASSO_MS (o mesmo 3s do CSS .cad-timeline.auto): um
        // ícone acende e apaga; depois do último, um passo com TODOS juntos
        // (destaque -1 + pulso) e recomeça do primeiro.
        const menosMovimento = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
        if (!menosMovimento) {
            const PASSO_MS = 3000
            this.passo = 0
            this.rodizio = setInterval(() => {
                this.passo = (this.passo + 1) % (BENEFICIOS.length + 1)
                const todos = this.passo === BENEFICIOS.length
                this.setState({ destaque: todos ? -1 : this.passo, pulso: todos })
            }, PASSO_MS)
        }
    }

    componentWillUnmount() {
        clearInterval(this.rodizio)
    }

    getPlaces = async () => {

        const BASE_URL = process.env.REACT_APP_BASE_URL

        await fetch(BASE_URL + '/places', {
            method: 'GET',
            headers: new Headers({
                'Authorization': 'Bearer ' + localStorage.getItem("nekb")
            })
        })
            .then(res => res.json())
            .then(data => {
                const response = data.toSorted((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))

                const selected = response.map((
                    {
                        name,
                        address,
                        city_state,
                        status,
                        userId,
                        brand_name
                    }) => (
                    {
                        name,
                        address,
                        city_state,
                        status,
                        userId,
                        brand_name
                    }))

                localStorage.setItem("places", JSON.stringify(selected))
            })
            .catch(rejected => {
                console.log(rejected)
            })

    }

    tryLogin = () => {

        if (this.state.loading) return

        const BASE_URL = process.env.REACT_APP_BASE_URL
        const user = {
            username: this.state.username,
            password: this.state.password
        }

        this.setState({ loading: true, loginMsg: '', inativa: false })

        fetch(BASE_URL + '/auth/login', {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(user)
        })
            .then(res => res.json())
            .then(async data => {
                if (data.error) {
                    // unidade inativa que ainda não pode voltar sozinha: mostra o caminho de volta
                    this.setState({ loginMsg: data.error, inativa: data.bloqueio === 'unidade_inativa', loading: false })
                } else {
                    // unidade inativa e pool bloqueado são recusados pelo servidor
                    // (403 com a mensagem) — caem no data.error acima
                    localStorage.setItem("resd", data.userAlive._id)
                    localStorage.setItem("username", data.userAlive.username)
                    localStorage.setItem("nekb", data.token)
                    localStorage.setItem("exp", moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'))
                    localStorage.setItem("side", "false")

                    if (data.userAlive.admin) {
                        localStorage.setItem("biwapp_secret", "VL101224")
                        localStorage.setItem("tabPath", "listlogins")
                        localStorage.setItem("viewType", "admin")

                        await this.getPlaces()
                    } else if (data.userAlive.pool) {
                        // Pool: enxerga um conjunto curado de unidades. Cai na Visão geral.
                        localStorage.setItem("pool_secret", "POOL_VL")
                        localStorage.setItem("tabPath", "overview")
                        localStorage.setItem("viewType", "pool")
                        localStorage.setItem("places", JSON.stringify(data.userAlive.places || []))
                        // nome do pool à parte: enterUnit troca o "username" pelo da unidade
                        localStorage.setItem("pool_nome", data.userAlive.username || "")
                    } else if (data.userAlive.bloqueio) {
                        // Assinatura self-serve suspensa ou encerrada: entra direto
                        // na página de regularizar/reativar (sem painel)
                        localStorage.setItem("tabPath", "assinatura")
                        localStorage.setItem("viewType", "bloqueado")
                    } else if (data.userAlive.onboarding) {
                        // Cadastro self-serve ainda no meio: a conta existe, o
                        // painel não — continua o onboarding de onde parou.
                        localStorage.setItem("tabPath", "onboarding")
                        localStorage.setItem("viewType", "onboarding")
                    } else {
                        salvarDadosDaUnidade(data.userAlive.places)
                    }

                    // sessão gravada: o App entra e leva à tela certa pelo
                    // router, sem recarregar (antes: sleep(1000) fixo + reload)
                    window.dispatchEvent(new Event("nekb"))
                }
            })
            .catch(rejected => {
                console.log(rejected)
                this.setState({ loginMsg: 'Não foi possível conectar. Tente novamente.', loading: false, inativa: false })
            });
    }

    handleSubmit = (event) => {
        event.preventDefault()
        this.tryLogin()
    }

    handlePasswordView = () => {
        this.setState(prevState => ({ showPassword: !prevState.showPassword }))
    }

    handleCapsLock = (event) => {
        if (event.getModifierState) {
            this.setState({ capsLock: event.getModifierState('CapsLock') })
        }
    }

    handleThemeToggle = () => {
        this.setState(prevState => {
            const nextIsDarkMode = !prevState.isDarkMode
            localStorage.setItem('login_theme', nextIsDarkMode ? 'dark' : 'light')
            return { isDarkMode: nextIsDarkMode }
        })
    }

    // ── Visual: mesma moldura do /cadastro (Onboarding/moldura) ─────────────
    // O painel da esquerda lista o que a BIWAPP faz pela loja; o formulário é
    // o de quem já tem conta. "Cadastre-se" leva ao /cadastro.
    render() {
        const { isDarkMode, showPassword, loading, loginMsg } = this.state

        return (
            <div className={'cad' + (isDarkMode ? ' dark' : '')}>
                <PainelMarca itens={BENEFICIOS.map((b, i) => ({ ...b, agora: i === this.state.destaque }))} automatico pulso={this.state.pulso}
                    texto="Entre para acompanhar os números da loja, as campanhas e o atendimento com I.A. — tudo num lugar só." />
                <main className="cad-form-side">
                    <button type="button" className="onb-icon-btn cad-theme" onClick={this.handleThemeToggle} aria-label="Alternar tema">
                        {isDarkMode ? <IoSunnyOutline size={18} /> : <IoMoonOutline size={18} />}
                    </button>

                    <form className="cad-form" noValidate onSubmit={this.handleSubmit}>
                        <div className="cad-form-head">
                            <span className="onb-kicker"><IoHandRightOutline size={13} /> Bem-vindo de volta</span>
                            <h2>Entre na sua conta</h2>
                            <p>Use o e-mail e a senha que você cadastrou.</p>
                        </div>

                        <div className="onb-grid">
                            <Campo id="login-email" label="E-mail" icone={IoMailOutline} autoFocus
                                type="email" name="username" autoComplete="username" inputMode="email"
                                placeholder="voce@sualoja.com.br" value={this.state.username}
                                onChange={e => this.setState({ username: e.target.value, loginMsg: '', inativa: false })} />

                            <Campo id="login-password" label="Senha" icone={IoLockClosedOutline}
                                rotuloExtra={<Link className="onb-forgot" to="/esqueci-senha">Esqueceu sua senha?</Link>}
                                type={showPassword ? 'text' : 'password'} name="password" autoComplete="current-password"
                                placeholder="Digite sua senha" value={this.state.password}
                                onChange={e => this.setState({ password: e.target.value, loginMsg: '', inativa: false })}
                                onKeyDown={this.handleCapsLock} onKeyUp={this.handleCapsLock}
                                dica={this.state.capsLock ? 'Caps Lock ativado' : ''}
                                adorno={<button type="button" onClick={this.handlePasswordView} aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}>
                                    {showPassword ? <IoEyeOutline size={18} /> : <IoEyeOffOutline size={18} />}
                                </button>} />

                            {loginMsg && !this.state.inativa && (
                                <div className="onb-alert error" role="alert">
                                    <IoAlertCircleOutline size={18} /><span>{loginMsg}</span>
                                </div>
                            )}
                            {loginMsg && this.state.inativa && (
                                <div className="onb-alert info login-inativa" role="alert">
                                    <IoRefreshOutline size={18} />
                                    <span>
                                        <strong>Sua loja está inativa.</strong> Quer voltar a usar a BIWAPP? Fale com a gente pelo WhatsApp — ajudamos você a reativar.
                                        <span className="login-inativa-acoes">
                                            <a className="onb-btn onb-btn-primary" href={linkAjuda('Oi! Quero reativar minha loja na BIWAPP. Meu login é ' + (this.state.username || '').trim() + '.')} target="_blank" rel="noopener noreferrer">
                                                <IoChatbubblesOutline size={16} /> Quero reativar minha loja
                                            </a>
                                        </span>
                                    </span>
                                </div>
                            )}

                            <button type="submit" className="onb-btn onb-btn-primary onb-btn-lg onb-btn-block" disabled={loading}>
                                {loading ? <><span className="onb-spinner" /> Entrando...</> : 'Entrar'}
                            </button>
                        </div>

                        <p className="cad-foot">Não possui uma conta? <Link to="/cadastro">Cadastre-se</Link></p>
                    </form>
                </main>
            </div>
        )
    }

}

export default Login;
